import React, {
  forwardRef,
  ForwardedRef
} from "react";
import classNames from "classnames";
import {ButtonIconType} from "./types";

export const SVVButtonIcon = forwardRef<HTMLButtonElement, ButtonIconType>(
  function ButtonInternal(
    props: ButtonIconType,
    ref: ForwardedRef<HTMLButtonElement>
  ) {
    const {
      square,
      size = "sm",
      ariaLabel,
      icon,
      className,
      ...restProps
    } = props;

    return (
      <button
        aria-label={ariaLabel}
        ref={ref}
        {...restProps}
        className={classNames("svv-button--icon-only", {
          "svv-button--icon-only--square": square,
          "svv-button--icon-only--md": size === "md",
          "svv-button--icon-only--lg": size === "lg",
        }, className)}
      >
        {icon}
      </button>
    )
  }
);

SVVButtonIcon.displayName = "SVVButton";
